import axios from "axios";
interface UserProfile {
  name: string;
  mobile: string;
  address: string;
}

export const getProfileApi = async (
  token: string,
  apiurl: string
): Promise<UserProfile | false> => {
  try {
    const response = await axios.get<UserProfile>(`${apiurl}/login/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(error);
    return false;
  }
};

export const updateProfileApi = async (
  url: string,
  token: string,
  name: string,
  mobile: string,
  address: string
) => {
  try {
    const response = await axios.post(
      `${url}/login/update`,
      {
        url,
        name,
        mobile,
        address,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};
